import { Form } from "antd";

import "./Filters.css"
import Editor from 'react-simple-wysiwyg';

export interface FilterTextEditorProps {
    onChange?:(value:string)=>void
    className?:React.HTMLAttributes<HTMLDivElement>['className'];
    onDeselect?:(value:any)=>void
    onClear?:()=>void
    required?:boolean,
    customRequiredText?:string,
    label?:string,
    placeholder?:string,
    dataKey:string,
    containerProps?:any
}

export function FilterTextEditor(props:FilterTextEditorProps){
    const rules=[{ required: props.required ?? false, message: props.customRequiredText ? props.customRequiredText : 'Il campo è obbligatorio' }]

    function onChange(value:any){
        if(props?.onChange){
            props?.onChange(value.target.value)
        }
    }

    const className = "filter " + (props?.className ?? "");

    return  <>
        <Form.Item name={props.dataKey}
                   label={props.label}
                   rules={rules}
        >
            <Editor containerProps={props.containerProps} className={className} placeholder={props.placeholder} onChange={onChange} />
        </Form.Item>
    </>

}